const SELF_ASSESSMENT_MAX_EXACT_LENGTH = 30;
const SELF_ASSESSMENT_MAX_EXACT_WORDS = 6;
const SENTENCE_MARK_PATTERN = /[.!?;]/g;
const LINE_BREAK_PATTERN = /\r?\n/;

export function isLikelySelfAssessmentAnswer(backText: string): boolean {
  const normalized = backText.trim();
  if (!normalized) {
    return false;
  }

  const wordCount = normalized.split(/\s+/).filter(Boolean).length;
  const sentenceMarkCount =
    normalized.match(SENTENCE_MARK_PATTERN)?.length ?? 0;

  return (
    normalized.length > SELF_ASSESSMENT_MAX_EXACT_LENGTH ||
    wordCount > SELF_ASSESSMENT_MAX_EXACT_WORDS ||
    sentenceMarkCount > 1 ||
    LINE_BREAK_PATTERN.test(normalized)
  );
}
